import { MyReviews } from "../../../features/notif&msg/myReviews";


export function MyReviewsPage(){

    return(
        <div>
            <MyReviews />
        </div>
    );
}